import { convertToUtcDate } from '@gravity/utils';
import getMonth from 'date-fns/get_month';
import getYear from 'date-fns/get_year';
import { connect } from 'react-redux';
import AvailabilityCalendarWidget from './AvailabilityCalendarWidget';

const mapStateToProps = (state, props) => {
  const configState = props.actions.config.getLocalState(state);
  const calendarState = props.actions.calendar.getLocalState(state);
  const filterState = props.actions.filter.getLocalState(state);
  return {
    waitingListEnabled: configState.configuration && configState.configuration.waitingListEnabled,
    calendar: calendarState,
    config: configState,
    filter: filterState,
    configError: configState.ERROR,
    configErrorCode: configState.ERROR_CODE,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  function loadMonth(year, month) {
    // Using withAllOccurrences param to get all occurrences per day for widget
    dispatch(
      props.actions.calendar.loadMonth(this.config, year, month, {
        filterCriteria: { withAllOccurrences: 'true' },
      }),
    );
  }
  /*
   * first load the range of months and then load the corresponding data.
   */

  async function loadMonths(productId) {
    const months = await dispatch(props.actions.calendar.loadMonths(this.config, productId));

    const firstDate =
      months &&
      months.calendarRange &&
      months.calendarRange[0] &&
      convertToUtcDate(new Date(months.calendarRange[0]));
    // use the first month where there are data as default value
    if (firstDate) {
      loadMonth.bind(this)(getYear(firstDate), getMonth(firstDate));
    }
  }

  /**
   * Action to be called when a day is selected.
   * @param {String} selectedDate, day selected
   */
  function changeDay(selectedDate) {
    dispatch(props.actions.filter.changeDay(selectedDate, selectedDate));
  }

  function logError(errorCode, error, info) {
    dispatch(props.actions.config.logError(errorCode, error, info));
  }
  return {
    loadMonths,
    loadMonth,
    logError,
    changeDay,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AvailabilityCalendarWidget);
